// Feature flags driven by build-time env vars. CRA inlines anything
// prefixed REACT_APP_ at build time, so these are constant booleans once
// the bundle is built — set them per-environment on Railway.
//
// Delivery Guru is being hidden on production while it gets reworked.
// Staging keeps it on so the team can keep iterating. Set
//   REACT_APP_DELIVERY_ENABLED=true
// on the staging Railway service. Leave it unset on production.

export const DELIVERY_ENABLED = process.env.REACT_APP_DELIVERY_ENABLED === 'true';
